import { render, staticRenderFns } from "./StudyActivityMini.vue?vue&type=template&id=3c330a82&scoped=true&"
import script from "./StudyActivityMini.vue?vue&type=script&lang=js&"
export * from "./StudyActivityMini.vue?vue&type=script&lang=js&"
import style0 from "./StudyActivityMini.vue?vue&type=style&index=0&id=3c330a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c330a82",
  null
  
)

export default component.exports